import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

const emptyForm = { nome: '', email: '', senha: '', role: 'USER' as 'ADMIN' | 'USER' };

export default function UsuariosPage() {
  const qc = useQueryClient();
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [form, setForm] = useState(emptyForm);

  const { data: users = [], isLoading } = useQuery({
    queryKey: ['users'],
    queryFn: () => api.get('/users').then(r => r.data),
  });

  const saveMutation = useMutation({
    mutationFn: (data: any) => editId ? api.put(`/users/${editId}`, data) : api.post('/users', data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['users'] }); setShowForm(false); },
  });

  const toggleMutation = useMutation({
    mutationFn: ({ id, ativo }: any) => api.put(`/users/${id}`, { ativo }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });

  function openNew() { setForm(emptyForm); setEditId(null); setShowForm(true); }
  function openEdit(u: any) { setForm({ ...u, senha: '' }); setEditId(u.id); setShowForm(true); }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">Usuários</h1>
        <button onClick={openNew} className="btn-primary">+ Novo</button>
      </div>

      {isLoading ? <div className="text-center py-8 text-gray-400">Carregando...</div> : (
        <div className="space-y-2">
          {users.map((u: any) => (
            <div key={u.id} className={`card ${!u.ativo ? 'opacity-60' : ''}`}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium">{u.nome}</div>
                  <div className="text-sm text-gray-500">{u.email}</div>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${u.role === 'ADMIN' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}`}>
                  {u.role === 'ADMIN' ? 'Admin' : 'Usuário'}
                </span>
              </div>
              <div className="flex gap-2 mt-2">
                <button onClick={() => openEdit(u)} className="text-sm text-blue-500">Editar</button>
                <button onClick={() => toggleMutation.mutate({ id: u.id, ativo: !u.ativo })} className="text-sm text-red-500">
                  {u.ativo ? 'Desativar' : 'Ativar'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div className="fixed inset-0 bg-black/50 z-40 flex items-end md:items-center justify-center">
          <div className="bg-white rounded-t-2xl md:rounded-2xl w-full md:max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-4 border-b flex justify-between">
              <h3 className="font-semibold">{editId ? 'Editar Usuário' : 'Novo Usuário'}</h3>
              <button onClick={() => setShowForm(false)}>✕</button>
            </div>
            <div className="p-4 space-y-3">
              <div>
                <label className="label">Nome *</label>
                <input className="input" value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} />
              </div>
              <div>
                <label className="label">Email *</label>
                <input type="email" className="input" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
              </div>
              <div>
                <label className="label">{editId ? 'Nova senha (deixe em branco para manter)' : 'Senha *'}</label>
                <input type="password" className="input" value={form.senha} onChange={e => setForm({...form, senha: e.target.value})} />
              </div>
              <div>
                <label className="label">Perfil</label>
                <select className="input" value={form.role} onChange={e => setForm({...form, role: e.target.value as any})}>
                  <option value="USER">Usuário</option>
                  <option value="ADMIN">Administrador</option>
                </select>
              </div>
              <div className="flex gap-3 pt-2">
                <button onClick={() => setShowForm(false)} className="btn-secondary flex-1">Cancelar</button>
                <button
                  onClick={() => saveMutation.mutate(form)}
                  disabled={!form.nome || !form.email || (!editId && !form.senha) || saveMutation.isPending}
                  className="btn-primary flex-1"
                >
                  {saveMutation.isPending ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
